<div class="header col gap-16">
    <img src="/images/default-agent.png" alt="Default Johnny Image" />
    <div class="col gap-4" i18n>
        <div class="uppercase-label">Hello there, Johnny here</div>
        <h2>Let’s do: {{ data.name }}.</h2>
    </div>
</div>
<div class="col gap-16 questions">
    <img src="/images/step-preview.png" alt="" class="w100" />
    @for(e of data.keyQuestions; track e.question){
    <div class="row gap-8 align-start">
        <rr-icon
            name="arrow-right"
            class="arrow"
            class="w24 arrow"
            color="nutral"
        ></rr-icon>
        <div class="col">
            <h4 class="strong">{{ e.title || e.question }}</h4>
            <div class="">{{ e.description }}</div>
        </div>
    </div>
    }
</div>
<div class="btnarea w100 row space-between align-center" i18n>
    @if (data.skipStepPreview === false) {
        <rr-checkbox (click)="skipDialog = !skipDialog">Skip next time</rr-checkbox>
    } @else {
        <!-- placeholder -->
        <div></div>
    }

    <rr-btn type="Primary" iconEnd="arrow-right" (click)="close()"
        >Let's do it</rr-btn
    >
</div>

